/**
 * Envelope colours, exported so the letter on the ground and the one in the
 * dog's jaws match exactly - the hand-off swaps one for the other on a single
 * frame, and any difference would show as a flicker.
 *
 * Pale gold rather than white: the page background is cream (#faf6ef), so a
 * white envelope would be invisible except for its outline.
 */
export const PAPER = '#f2dcae'
export const PAPER_EDGE = '#c08f4c'
const SEAL = '#9d4b52'
const SEAL_RING = '#c07278'

/** The folded RSVP, waiting on the ground for the dog. */
export function Letter({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 120 82" className={className} role="presentation" aria-hidden="true">
      <rect
        x="2"
        y="2"
        width="116"
        height="78"
        rx="4"
        fill={PAPER}
        stroke={PAPER_EDGE}
        strokeWidth="2.5"
      />
      {/* Envelope flap. */}
      <path d="M2 5 L60 46 L118 5" fill="none" stroke={PAPER_EDGE} strokeWidth="2.5" />
      {/* Wax seal. */}
      <circle cx="60" cy="48" r="11" fill={SEAL} />
      <circle cx="60" cy="48" r="7" fill="none" stroke={SEAL_RING} strokeWidth="1.5" />
    </svg>
  )
}
